<template>
  <div class="loader">
    <div class="loading-circles"><div></div><div></div></div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>

<style scoped lang="scss">
.loader {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  // background-color: rgb(135,135,135);
}

.loading-circles {
  position: absolute;
  display: inline-block;
  margin: auto auto;
  top: 0; right: 0; bottom: 0; left: 0;
  width: 64px;
  height: 64px;
}

.loading-circles div {
  position: absolute;
  border: 4px solid $color-brand;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.loading-circles div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 28px;
    left: 28px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: -1px;
    left: -1px;
    width: 58px;
    height: 58px;
    opacity: 0;
  }
}
</style>
